import { NgModule } from '@angular/core';
import { MaterialModule } from 'src/app/services/material.module';
import { SharedModule } from 'src/app/services/shared.module';
import { SyncfusionModule } from 'src/app/services/syncfusion.module';
import { HeaderPagesRoutingModule } from './header-pages-routing.module';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { LabPrinterComponent } from './lab-printer/lab-printer.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { SupportComponent } from './support/support.component';
import { AddEditIssueComponent } from './support/add-edit-issue/add-edit-issue.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  declarations: [
    ChangePasswordComponent,
    LabPrinterComponent,
    PrivacyPolicyComponent,
    SupportComponent,
    AddEditIssueComponent,
    ForgotPasswordComponent,
  ],
  imports: [
    SharedModule,
    MaterialModule,
    NgxMaskModule.forRoot(),
    SyncfusionModule,
    HeaderPagesRoutingModule,
  ],
  entryComponents: [
    ChangePasswordComponent,
    LabPrinterComponent,
    PrivacyPolicyComponent,
    SupportComponent,
    AddEditIssueComponent,
    ForgotPasswordComponent,
  ]
})
export class HeaderPagesModule { }
